import { Grid } from '@material-ui/core';
import { SmallSectionHeader } from 'components/Typography';
import GaClickHOC from 'helpers/GATracking/GaClickHOC';
import { truncate } from 'lodash';
import React from 'react';
import { OffreItemProp } from 'components/OffresBlock/types';
import {
  StyledGrid,
  StyledShortBody,
  StyledButton,
  StyledLink,
} from 'components/OffresBlock/style';

const OffreItem = (props: OffreItemProp) => {
  return (
    <Grid item>
      <StyledGrid
        backgroundImage={props.backgroundImage}
        container
        direction="column"
        justify="space-between"
      >
        <Grid item>
          <Grid container>
            {props.title && (
              <Grid item>
                <SmallSectionHeader color={'white'}>
                  {props.title}
                </SmallSectionHeader>
              </Grid>
            )}
            {props.body && (
              <Grid item>
                <StyledShortBody color={'white'}>
                  {truncate(props.body, { length: 130 })}
                </StyledShortBody>
              </Grid>
            )}
          </Grid>
        </Grid>
        <Grid container justify="flex-end">
          <Grid item xs={8}>
            <GaClickHOC category={props.category} label={props.label}>
              <StyledLink href={props.link} target="_blank">
                <StyledButton>{props.ctaText}</StyledButton>
              </StyledLink>
            </GaClickHOC>
          </Grid>
        </Grid>
      </StyledGrid>
    </Grid>
  );
};

export default OffreItem;
